// extracted by mini-css-extract-plugin
module.exports = {"candidateTable":"newCandidate_candidateTable__3gxbb","ListBodyContainer":"newCandidate_ListBodyContainer__12CzK"};